import React from "react";
import NotificationItem from "./NotificationItem";

function NotificationView (props) {
    return (
        props?.notifications.map((item)=> {
            const notificationKey = item?.notificationId?._id || item?._id || item?.updated?.on || item?.notificationId?.title;
            return <NotificationItem key={notificationKey} item={item} deleteNotificationById={props.onDeleteNotification} settingsData={props?.settingsData} />
        })
    );
}

export default NotificationView;